import { nanoid } from "nanoid";

const firebaseUid = () => `-M${nanoid()}`;

export default firebaseUid;
